/* eslint-disable padded-blocks */
import $ from "jquery";
import { courseReportFilters } from "./courseReportFilters";
import { dataaccess } from "../dataaccess/dataContext";

let disclosureFormReportTable;
let currentPage = 1;
let pageSize = 20;
let totalMatchedRecords = 0;
let hasNextPage;
let sort = {};
let dataSet = [];
const tableColumns = [
    "PersonId",
    "FirstName",
    "LastName",
    "Email",
    "DisclosureForm",
    "Program",
    "ProgramId"
];


function init() {
    $("#btnApplyFilters").click(applyFilters);
    $("#btnDownloadExcel").click(downloadReport);
    $("#next").click(goNextPage);
    $("#previous").click(goPreviousPage);
    $(".sorting, .sorting_asc, .sorting_desc").click(applySort);
    buildTable();
    
    $(document).on("click", ".js-view-form", function () {   
        const disclosureId = $(this).data("id");
        dataaccess
            .get({ url: `/DisclosureForm/View/${disclosureId}` })
            .done(function (htmlResult) {              
                $("#AddDisclosureModal .modal-content").html(htmlResult);
                const $form = $("#AddDisclosureForm");
                $form.find("button, input, textarea").prop("disabled", true);
                $("#addNewRelationship")
                    .closest("tr")
                    .hide();
            });
    });

      $(document).on("click", ".js-coi-modal", function() {
        const $btn = $(this);
        const disclosureId = $btn.data("id");
        const programId = $btn.data("programid");
        const isReadOnly = 'true';
        $("#CoiModal").modal("show");        
        dataaccess
            .get({
                url:
                    `/CourseRoster/ConflictOfInterest?disclosureId=${disclosureId}&programId=${programId}`
            })
            .done(function(result) {
                $("#CoiModal .modal-body").html(result);

                if (isReadOnly) {
                    $("#CoiForm").find("button, input").prop("disabled", true);
                } else {
                    dateFormatter.initDatePicker();
                }
            });
    });

}

function buildDataSet(disclosureForms) {

    dataSet = [];
    if (!disclosureForms || !disclosureForms.length) { return; }
    for (let i = 0; i < disclosureForms.length; i++) {
        dataSet.push([
            disclosureForms[i].personId,
            disclosureForms[i].firstName,
            disclosureForms[i].lastName,
            disclosureForms[i].emailId,
            disclosureForms[i].disclosureFormId,
            disclosureForms[i].conflictOfInterestId,
            disclosureForms[i].program,
            disclosureForms[i].programId

        ]);
    }
    hasNextPage = (currentPage * pageSize) < totalMatchedRecords;
    setNextPrevButtonEnabled();
}

function buildTable() {
    disclosureFormReportTable = $("#disclosureFormReportTable").DataTable({
        "serverSide": false, // for process server side
        "filter": false, // this is for disable filter (search box)
        //"orderMulti": false, // for disable multiple column at once
        "data": dataSet,
        "bLengthChange": false,
        "bPaginate": false,
        "PageLength": 20,
        "bInfo": false,
        "ordering": false,
        "columnDefs":
            [
                {
                    "targets": 0,
                    "name": "personId"
                },
                {
                    "targets": 1,
                    "name": "firstName"
                },
                {
                    "targets": 2,
                    "name": "lastName"
                },
                {
                    "targets": 3,
                    "name": "emailId"
                },
                {
                    "targets": 4,
                     render: renderDisclosureFormFunction
                },
                {
                    "targets": 5,
                    "name": "coi",
                     visible: false
                },
                {
                    "targets":6,
                    "name": "program"
                },
                {
                    "targets": 7,
                    "name": "programId",
                     visible: false
                }
            ]
    });
}

function renderDisclosureFormFunction(data, type, row) {
    if (data === undefined || data.length <= 0) return "";
    let button = "";
    button =
        "<button class='tn btn-link js-view-form text-primary' data-toggle='modal' data-target='#AddDisclosureModal' " +
        " data-id= " + data +
        " data-personid= " + row[1] + " > <i class='fas fa-flag fa-lg'></i> </button>";
        if (row[5] > 0) {
        button = button + "<button class='btn btn-link text-primary js-coi-modal' style='cursor: pointer;' title='Conflict of Interest'" +
            " data-id= " + data +
            " data-personid= " + row[1] +
            " data-programid= " + row[7] +
            "> <span class= 'badge badge-pill' > COI</span > </button>";
    }
    return button;
}




function downloadReport() {
    let source = $(this).attr("href");
    if (!source.endsWith("?")) {
        source += "?";
    }
    const sourceWithParams = source += $.param(getFilters().getQueryStringFilters()).replace(/%5B%5D/g, "");
    $(this).attr("href", sourceWithParams);
}

function goNextPage() {
    if (!hasNextPage) return;
    currentPage++;
    applyFilters(getFilters(), false);
}
function goPreviousPage() {
    if (currentPage === 1) return;
    currentPage--;
    applyFilters(getFilters(), false);
}



function setNextPrevButtonEnabled() {
    if (!hasNextPage) {
        $("#next").addClass("disabled");
    } else {
        $("#next").removeClass("disabled");
    }
    if (currentPage === 1) {
        $("#previous").addClass("disabled");
    } else {
        $("#previous").removeClass("disabled");
    }
}
function applyFilters(isNewSearch) {

    const filters = getFilters();
    if (filters.yearReceived == null) {
        return;
    }

    // Resetting current page number to 1 as it is fresh new search criteria(user clicked on the "Run Report" button)
    if (arguments.length === 1 || (arguments[1] && isNewSearch))
        currentPage = 1;   
    getData().then(function (data) {
        $("#PagingInfo").text("Page " + data.currentPage + " of " + data.pageCount + ". Matched records = " + data.rowCount);
        pageSize = data.pageSize;
        totalMatchedRecords = data.rowCount;
        if (data.results) {
            buildDataSet(data.results);
        }           
        else {
            buildDataSet(data);
        }
     
        disclosureFormReportTable.clear();        
        disclosureFormReportTable.rows.add(dataSet).draw();     
        setNextPrevButtonEnabled();
    });
}
function applySort(e) {
    const asc = $(this).hasClass("sorting") || $(this).hasClass("sorting_desc");
    $(".sorting, .sorting_asc, .sorting_desc").removeClass()
        .addClass("sorting");

    if (asc) {
        $(this).removeClass("sorting").removeClass("sorting_desc").addClass("sorting_asc");
    } else {
        $(this).removeClass("sorting").removeClass("sorting_asc").addClass("sorting_desc");
    }
    $(".sorting, .sorting_asc, .sorting_desc").not($(this)).removeClass(".sorting_asc").removeClass(".sorting_desc")
        .addClass("sorting");
    sort = {
        column: tableColumns[disclosureFormReportTable.column(this).index()],
        desc: $(this).hasClass("sorting_desc")
    };
    applyFilters(false);
}

function getFilters() {
    return {
        yearReceived: toIntOrNull($("#yearReceived").val()),
    };
}
function toIntOrNull(val) {
    const parsed = parseInt(val);
    if (isNaN(parsed)) { return null; }
    return parsed;
}

function getData() {
    const filters = getFilters();
    filters.desc = sort.desc;
    filters.sortColumn = sort.column || "";
    return dataaccess.post({ url: "/DisclosureFormReport/GetDisclosureFormReportResponses/Responses/" + currentPage, data: filters });
}

export const disclosureFormReport = {
    init: init
};